/**
 * Builds the Stats URL that signs the user in, with the token in the fragment.
 *
 * Returns the URL unchanged when it is not https or does not parse, so the caller
 * falls back to the cookie alone instead of putting the token on a plaintext page.
 * The configured brand URL must not redirect: a redirect carries the fragment to
 * the target host.
 */
export const buildStatsSignInUrl = (statsUrl: string, accessToken: string) => {
    try {
        const url = new URL(statsUrl);

        if (url.protocol !== 'https:') {
            return statsUrl;
        }

        url.hash = `access_token=${encodeURIComponent(accessToken)}`;

        return url.toString();
    } catch {
        return statsUrl;
    }
};
